<template>
  <section class="handyrechnung-stores__faq stores-faq">
    <GridContainer
      padding
      class="stores-faq__container"
    >
      <p class="stores-faq__eyebrow">Häufige Fragen</p>
      <Heading
        tag="h2"
        size="lg"
        align="center"
        spaces-bottom-rem
      >
        Antworten zur Bezahlung per Handyrechnung im App Store.
      </Heading>

      <div class="stores-faq__columns">
        <div class="stores-faq__list">
          <AccordionItem
            v-for="(item, i) in firstColumn"
            :key="i"
          >
            <template #title>
              <h3>{{ item.question }}</h3>
            </template>
            <template #content>
              <div
                class="unstyled-html"
                v-html="item.answer"
              />
            </template>
          </AccordionItem>
        </div>
        <div class="stores-faq__list">
          <AccordionItem
            v-for="(item, i) in secondColumn"
            :key="i"
          >
            <template #title>
              <h3>{{ item.question }}</h3>
            </template>
            <template #content>
              <div
                class="unstyled-html"
                v-html="item.answer"
              />
            </template>
          </AccordionItem>
        </div>
      </div>
    </GridContainer>
  </section>
</template>

<script setup lang="ts">
import { GridContainer, Heading, AccordionItem } from '@i22team/td-longtail-vue-components';

const faqs = [
  {
    question: 'Bei welchen Apps und Games funktioniert das?',
    answer:
      'Bei allen Apps, Abos und Games im App Store oder Google Play, die die Bezahlung per Handyrechnung unterstützen, von In-App-Käufen über App-Abos bis Apple Arcade und Google Play Pass.',
  },
  {
    question: 'Wie funktioniert das 100 % Cashback?',
    answer:
      'Du bekommst 100 % deines ersten Kaufs nach der Anmeldung zurück, bis maximal 10&nbsp;€. Die Gutschrift erscheint auf deiner Telekom Rechnung, einmal pro Kunde.',
  },
  {
    question: 'Brauche ich eine Kreditkarte oder Bank?',
    answer:
      'Nein. Die Bezahlung per Handyrechnung läuft komplett über deinen Telekom Mobilfunkvertrag, ohne Karte, ohne Konto, ohne Bonitätsprüfung.',
  },
  {
    question: 'Geht das bei Apple und Google?',
    answer:
      'Ja, du hinterlegst die Handyrechnung bei Apple in den Profil-Einstellungen und in der Google Play App in den Zahlungsmethoden.',
  },
  {
    question: 'Was, wenn keine SMS zur Bestätigung kommt?',
    answer:
      'Dann ist meist die Drittanbietersperre aktiv. Diese kannst du in der MeinMagenta App im Mehr-Menü unter „Drittanbietersperre“ aufheben.',
  },
  {
    question: 'Muss ich die Bezahlung erst freischalten?',
    answer:
      'Falls die Zahlung per Handyrechnung nicht möglich ist, kann eine Drittanbietersperre vorliegen. Diese kannst du in der MeinMagenta App im Mehr-Menü unter „Drittanbietersperre“ aufheben. Alternativ logge dich unter <a href="https://drittanbieterinfo.de/" target="_blank" rel="noopener" class="link link--external">drittanbieterinfo.de</a> mit deiner Rufnummer ein und bearbeite die Drittanbietersperren. Nach dem Speichern der Änderungen kannst du den Kaufvorgang wiederholen.',
  },
  {
    question: 'Wo sehe ich den Posten auf der Rechnung?',
    answer:
      'In MeinMagenta unter „Rechnungen → Drittanbieter-Leistungen“. Dort ist jeder App-Store- bzw. Google-Play-Kauf mit Datum und Betrag aufgeführt.',
  },
  {
    question: 'Kann ich beliebig oft so zahlen?',
    answer:
      'Ja, du kannst alle deine App-Käufe per Handyrechnung zahlen. Das 100 % Cashback gilt einmalig für deinen ersten Kauf.',
  },
];

const splitAt = computed(() => Math.ceil(faqs.length / 2));
const firstColumn = computed(() => faqs.slice(0, splitAt.value));
const secondColumn = computed(() => faqs.slice(splitAt.value));
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.stores-faq {
  padding-block: 3rem;

  @include mq($mq-md) {
    padding-block: 4rem;
  }

  &__container {
    max-width: 1280px;
  }

  &__eyebrow {
    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
    color: var(--color-primary);
    margin-bottom: 12px;
    text-align: center;
  }

  &__columns {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem 1rem;

    @include mq($mq-md) {
      grid-template-columns: 1fr 1fr;
    }
  }

  &__list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-self: start;
  }

  :deep(.accordion-item__title) {
    border-radius: 1rem;

    &:hover {
      background-color: transparent;
    }
  }

  :deep(.accordion-item) {
    width: 100%;
    --accordion-title-padding: 1rem;
    --accordion-content-padding: 1rem;
    border: 1px solid var(--color-gray-100);
    border-radius: 1rem;
    padding-block: 0;
  }

  :deep(.accordion-item--is-open) {
    border: 1px solid var(--color-primary);
  }
}
</style>
